'use client'

import { useBIPageView } from '@/context/BISdkContext'
import { PropsWithChildren } from 'react'

function CreatorIntroPageWrapper({ children }: PropsWithChildren) {
  useBIPageView()

  return (
    <main className="relative flex min-h-screen flex-1 flex-col overflow-hidden">{children}</main>
  )
}

export default CreatorIntroPageWrapper
